import 'core-js/actual/object/from-entries';
import 'core-js/actual/promise';
import 'core-js/actual/dom-collections/iterator';
import 'core-js/actual/string/replace-all';